import React from "react";
import { Tooltip, IconButton, Box, Typography } from "@mui/material";
import { Help, Info } from "@mui/icons-material";

const AssessmentRiskTooltip = ({
  assessmentType = "Environmental",
  riskLevels = [],
  icon: CustomIcon = Help,
  iconColor = "action",
  size = "small",
  placement = "right",
}) => {
  const renderTooltipContent = () => (
    <Box
      sx={{
        maxWidth: 350,
        p: 2.5,
        backgroundColor: "#ffffff",
        borderRadius: 1,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: "#1976d2",
          fontSize: "1rem",
          textAlign: "center",
          pb: 1,
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        {assessmentType} Assessment Levels
      </Typography>
      {riskLevels.map((level, index) => (
        <Box
          key={index}
          sx={{
            mb: 1.5,
            "&:last-child": { mb: 0 },
            p: 1.5,
            backgroundColor: "#f8f9fa",
            borderRadius: 1,
            border: "1px solid #e9ecef",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              mb: 0.5,
              color: "#212529",
              fontSize: "0.875rem",
            }}
          >
            {level.label} {level.scoreRange && `(Score: ${level.scoreRange})`}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#6c757d",
              fontSize: "0.8rem",
              lineHeight: 1.4,
            }}
          >
            {level.description}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  return (
    <Tooltip
      title={renderTooltipContent()}
      placement={placement}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "#ffffff",
            color: "#212529",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            maxWidth: "none !important",
            "& .MuiTooltip-arrow": {
              color: "#ffffff",
              "&::before": {
                border: "1px solid #e0e0e0",
              },
            },
          },
        },
      }}
    >
      <IconButton
        size={size}
        sx={{
          ml: 1,
          color: iconColor === "action" ? "#6c757d" : undefined,
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.08)",
            color: "#1976d2",
          },
          transition: "all 0.2s ease-in-out",
        }}
      >
        <CustomIcon fontSize={size} color={iconColor} />
      </IconButton>
    </Tooltip>
  );
};

export default AssessmentRiskTooltip;
